import Service from './Service'
import { DEBUG_USER_STATS, DEBUG_OPTION_STATS } from './apiUrls'

export default class ChartService extends Service {
  getUserStats (query) {
    return this.axios.get(DEBUG_USER_STATS, {params: query})
  }
  getOptionStats (query) {
    return this.axios.get(DEBUG_OPTION_STATS, {params: query})
  }
}



// WEBPACK FOOTER //
// ./src/services/api/DebugService.js